export const Experiments = {
  TrackingEvents: {
    donateButtonClick: 'donateButtonClick',
    shareModalOpen: 'shareModalOpen',
    shareSocialButtonClick: 'shareSocialButtonClick',
    verifiedCharity: 'verifiedAnchorClick',
  },
  ConsumerFintech: {
    CheckoutConversion: {
      PopupSideBySide: {
        flagKey: 'consumerfintech_jgcheckout_conversion_pop-up_sbs_view_f25',
      },
    },
  },
  ConsumerDarkslide: {
    VerifiedCharity: {
      flagKey: 'consumerdarkslide_verifiedcharity_2601419',
    },
    DonationPrompts: {
      flagKey: 'consumerdarkslide_2601425_donor_engagement_x_buys_y',
    },
  },
};
